import { PageType } from '@blk/simba';

export const ADVISOR_LANDSCAPE_HEADER = (familyName, modelSubscriptLabel) => `
<g id="Master-header">
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="8" font-weight="300" fill="#616161">
		<tspan x="1" y="5">${familyName} ${modelSubscriptLabel}</tspan>
	</text>
	<path d="M0.5,10.5 L${PageType.LetterLandscape.contentWidth}.5,10.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
</g>`;

export const ADVISOR_LANDSCAPE_FOOTER = (footerDcr) => `
<g id="Report_ClientFooter" fill="#616161" font-family="FortBook" font-size="8">
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterLandscape.contentWidth}" y="5">REPORT GENERATED ON</tspan><tspan
			   text-anchor="end" x="${PageType.LetterLandscape.contentWidth}" y="14">$date$</tspan><tspan
			   text-anchor="end" x="${PageType.LetterLandscape.contentWidth}" y="23">PAGE $pageNo$ of $pageTotal$</tspan>
	</text>
	$${footerDcr}$
</g>`;
